module.exports = __webpack_public_path__ + "img/news-pic-detail.png?24dae1fec9b37cfe7a1b5de3642f10df";